import { render } from "./Waiting.vue?vue&type=template&id=16fc0da8&scoped=true"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"

import "./Waiting.vue?vue&type=style&index=0&id=16fc0da8&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fc0da8"]])

export default __exports__